<template>
  <Download class="download-body" style="z-index: 1; position: relative" />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { ActionTypes, MutationTypes, useStore } from "@/store";
import router from "@/router";
import useGlobalHotkey from "@/hooks/useGlobalHotkey";
import usePasteEvent from "@/hooks/usePasteEvent";
import useSlideHandler from "@/hooks/useSlideHandler";
import Download from "./Canvas/cover.vue";
// 引入接口
import { EditorService } from "@/api/editor";
import { message } from "ant-design-vue";
import { CommonService } from "@/api/common";
export default defineComponent({
  name: "preview",
  components: {
    Download,
  },
  setup() {
    const store = useStore();
    const remarkHeight = ref(40);
    const visibleDrawer = computed(() => store.state.eleDrawerState);
    const visibleThumb = computed(() => store.state.eleThumbState);
    const fontsList = ref([]);
    const pageSize = ref(500);
    const pageNumber = ref(1);
    const pageSum = ref(0);
    const currFont = ref([]);
    const currFontOld = ref([]);
    const sildeFonts = computed(() => store.state.slideFonts);

    const getFonts = async () => {
      const params = {
        pageSize: pageSize.value,
        pageNumber: pageNumber.value,
      };
      const res = await EditorService.getFontList(params);
      if (res.data.state === 2) {
        fontsList.value = res.data.data;
        store.commit(MutationTypes.SET_SLIDES_FONTS_LIST, fontsList.value);
        pageSum.value = res.data.pageSum;
        sildeFonts.value.map((k: any) => {
          res.data.data.map((f: any) => {
            if (k === f.enName) {
              currFont.value.push(f as never);
            }
            if (k === f.name) {
              currFontOld.value.push(f as never);
            }
          });
        });
        document.getElementById("font-f")?.remove();
        const style = document.createElement("style");
        style.id = "font-f";
        style.type = "text/css";
        currFont.value.forEach((f: any) => {
          style.innerText +=
            "@font-face {font-family:'" + f.enName + "';src:url('" + f.filePath + "')}";
        });
        currFontOld.value.forEach((f: any) => {
          style.innerText +=
            "@font-face {font-family:'" + f.name + "';src:url('" + f.filePath + "')}";
        });
        document.getElementsByTagName("head")[0].appendChild(style);
      }
    };
    const LOAD_FONTS = (data: any) => {
      let fontArr: any[] = [];
      const fonts: any[] = [];
      data.forEach((item: any) => {
        item.elements.forEach((ele: any) => {
          if (ele.type === "text") {
            fontArr.push(
              String(
                ...new Set(
                  ele.content && ele.content.match(/(font-family:[^><;"]*(;)?)/gi)
                )
              )
            );
            if (ele.defaultFontName) {
              fontArr.push("font-family: " + ele.defaultFontName);
            }
          } else if (ele.type === "rect") {
            fontArr.push(
              String(
                ...new Set(
                  ele.text && ele.text.content.match(/(font-family:[^><;"]*(;)?)/gi)
                )
              )
            );
          } else if (ele.type === "shape") {
            fontArr.push(
              String(
                ...new Set(
                  ele.text && ele.text.content.match(/(font-family:[^><;"]*(;)?)/gi)
                )
              )
            );
          }
        });
      });

      fontArr = [...new Set(fontArr)];
      if (fontArr.length > 0) {
        fontArr.forEach((item) => {
          if (item !== "") {
            const f = String(item);
            fonts.push(f.split(":")[1].replace(/ /g, ""));
          }
        });
      }
      store.commit(MutationTypes.SET_SLIDES_FONTS, fonts);
      getFonts();
    };
    const { resetSlides } = useSlideHandler();
    const viewportWidths = ref();
    const viewportHeights = ref();
    const viewportWidth = ref(Number(router.currentRoute.value.query.width));
    const viewportHeight = ref(Number(router.currentRoute.value.query.height));
    const viewportType = ref(router.currentRoute.value.query.unit);
    const viewportRatio = viewportHeight.value / viewportWidth.value;
    const mode = ref(router.currentRoute.value.query.mode);
    const cid = ref(router.currentRoute.value.query.cid);
    const cm = ref(28.333);
    const mm = ref(2.833);
    if (viewportType.value === "cm") {
      viewportWidths.value = Number((viewportWidth.value * cm.value).toFixed(2));
      viewportHeights.value = Number((viewportHeight.value * cm.value).toFixed(2));
    } else if (viewportType.value === "mm") {
      viewportWidths.value = Number((viewportWidth.value * mm.value).toFixed(2));
      viewportHeights.value = Number((viewportHeight.value * mm.value).toFixed(2));
    } else {
      viewportWidths.value = viewportWidth.value;
      viewportHeights.value = viewportHeight.value;
    }
    if (mode.value === "create") {
      if (!cid.value) {
        store.commit(MutationTypes.SET_VIEWPORT_RATIO, viewportRatio);
        store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTH, viewportWidths.value);
        store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHT, viewportHeights.value);
        store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTHS, viewportWidth.value);
        store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHTS, viewportHeight.value);
        store.commit(MutationTypes.SET_VIEWPORT_RATIO_TYPE, viewportType.value);
        store.dispatch(ActionTypes.INIT_SNAPSHOT_DATABASE);
      } else {
        const getScenesDetail = async () => {
          const detail = await EditorService.getScenesDetail(cid.value);
          const data = detail.data.data;
          const width = ref(0);
          const height = ref(0);
          if (data.unit === "cm") {
            width.value = Number((data.width * cm.value).toFixed(2));
            height.value = Number((data.height * cm.value).toFixed(2));
          } else if (data.unit === "mm") {
            width.value = Number((data.width * mm.value).toFixed(2));
            height.value = Number((data.height * mm.value).toFixed(2));
          } else {
            width.value = data.width;
            height.value = data.heigh;
          }
          store.commit(MutationTypes.SET_VIEWPORT_RATIO, data.heigh / data.width);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTH, width.value);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHT, height.value);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTHS, data.width);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHTS, data.heigh);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_TYPE, data.unit);
          store.dispatch(ActionTypes.INIT_SNAPSHOT_DATABASE);
        };
        getScenesDetail();
      }
      resetSlides();

      getFonts();
    } else {
      const id = ref("");
      if (router.currentRoute.value.query.code) {
        id.value = String(router.currentRoute.value.query.code);
        const getUserTemplateList = async () => {
          let detail = null;
          let data = null;
          if (router.currentRoute.value.query.project) {
            detail = await CommonService.getSpaceContentdetail(id.value);
            if (detail.data.state === 0) {
              message.error(detail.data.msg);
              router.push("/space");
              return;
            }

            data = detail.data.data.pptContent;
          } else {
            detail = await CommonService.getContentdetail(id.value);
            if (detail.data.state === 0) {
              message.error(detail.data.msg);
              router.push("/space");
              return;
            }

            data = detail.data.data.pptContent;
          }
          const width = ref(0);
          const height = ref(0);
          if (data.content[0].unit === "cm") {
            width.value = Number((data.content[0].width * cm.value).toFixed(2));
            height.value = Number((data.content[0].height * cm.value).toFixed(2));
          } else if (data.content[0].unit === "mm") {
            width.value = Number((data.content[0].width * mm.value).toFixed(2));
            height.value = Number((data.content[0].height * mm.value).toFixed(2));
          } else {
            width.value = data.content[0].width;
            height.value = data.content[0].height;
          }
          data.content.forEach((item: { checked: boolean }) => {
            item.checked = true;
          });
          store.commit(
            MutationTypes.SET_VIEWPORT_RATIO,
            data.content[0].height / data.content[0].width
          );
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTH, width.value);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHT, height.value);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTHS, data.content[0].width);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHTS, data.content[0].height);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_TYPE, data.content[0].unit);
          store.commit(MutationTypes.SET_SLIDES, data.content);
          store.commit(MutationTypes.SET_TITLE, data.title);
          store.commit(MutationTypes.SET_SCENCE, data.scenes || {});
          store.commit(MutationTypes.SET_PREVIEW_URL, data.preview || "");
          store.dispatch(ActionTypes.INIT_SNAPSHOT_DATABASE);
          LOAD_FONTS(data.content);
          getFonts();
        };
        getUserTemplateList();
      }
      if (router.currentRoute.value.query.id) {
        id.value = String(router.currentRoute.value.query.id);
        const getUserTemplateList = async () => {
          const res = await EditorService.getTemplatesDetail(id.value);
          if (res.data.state === 0) {
            message.error(res.data.msg);
            router.push("/space");
            return;
          }
          const data = JSON.parse(res.data.data.content);
          const width = ref(0);
          const height = ref(0);
          if (data[0].unit === "cm") {
            width.value = Number((data[0].width * cm.value).toFixed(2));
            height.value = Number((data[0].height * cm.value).toFixed(2));
          } else if (data[0].unit === "mm") {
            width.value = Number((data[0].width * mm.value).toFixed(2));
            height.value = Number((data[0].height * mm.value).toFixed(2));
          } else {
            width.value = data[0].width;
            height.value = data[0].heigh;
          }
          store.commit(MutationTypes.SET_VIEWPORT_RATIO, data[0].height / data[0].width);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTH, width.value);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHT, height.value);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTHS, data[0].width);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHTS, data[0].height);
          store.commit(MutationTypes.SET_VIEWPORT_RATIO_TYPE, data[0].unit);
          store.commit(MutationTypes.SET_SLIDES, data);
          store.commit(MutationTypes.SET_TITLE, res.data.data.title);
          store.commit(MutationTypes.SET_SCENCE, {});
          store.dispatch(ActionTypes.INIT_SNAPSHOT_DATABASE);
          LOAD_FONTS(data);
          getFonts();
        };
        getUserTemplateList();
      }
    }
    onMounted(() => {
      window.onpopstate = () => {
        history.go(1);
      };
    });
    useGlobalHotkey();
    usePasteEvent();
    return {
      remarkHeight,
      visibleDrawer,
      visibleThumb,
    };
  },
});
</script>

<style lang="scss" scoped>
html,
body {
  background: transparent;
}
.editors {
  height: 100%;
}
.download-body {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
}
.layout-header {
  height: 56px;
}
.layout-content {
  height: calc(100% - 56px);
  display: flex;
}
.layout-content-left {
  position: relative;
  width: 59px;
  height: 100%;
  flex-shrink: 0;
}
.layout-content-center {
  width: calc(100% - 59px - 260px);
  transition: all 0.4s;
  background-color: $lightGray;
  .center-top {
    height: 50px;
  }
}
.layout-content-right {
  width: 260px;
  height: 100%;
}
.layout-content-center.showDrawer {
  padding: 0 0 0 310px;
}
.layout-content-center.showThumb {
  padding: 0 0 0 160px;
}
</style>
